module.exports = __webpack_public_path__ + "static/first-in-flight-tee-29497567665d896ba4e2fa0a16045131.webp";